export default __webpack_public_path__ + "static/media/img_vision_06_2_w.91ce3cc4.png";